import { render, staticRenderFns } from "./TimetableMetaCreate.vue?vue&type=template&id=a24901f4&scoped=true"
import script from "../../controllers/timetable_meta/timetable-meta-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/timetable_meta/timetable-meta-create.js?vue&type=script&lang=js&external"
import style0 from "./TimetableMetaCreate.vue?vue&type=style&index=0&id=a24901f4&prod&lang=css"
import style1 from "./TimetableMetaCreate.vue?vue&type=style&index=1&id=a24901f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24901f4",
  null
  
)

export default component.exports